<template>
  <div class="formulaListLeft">
    <div class="header">
      <el-input
        class="header_search"
        placeholder="搜索姓名/手机/配方单号"
        prefix-icon="el-icon-search"
        v-model.trim="search.keyword"
        clearable
        @input="handleSearch">
      </el-input>
    </div>
    <div v-if="search.status" class="search_result">搜索到<span class="search_result_num">{{ user.total }}</span>条信息</div>
    <div v-else class="tab">
      <div class="tab_list">
        <div
          v-for="(item, index) in tab.list"
          :key="index"
          :class="{ tab_list_item: true, active: tab.active === item.status }"
          @click="tabChange(index)">
          <span class="tab_list_item_text">{{ item.text }}</span>
          <span v-show="!!item.mark" class="tab_list_item_mark">{{ item.mark }}</span>
        </div>
      </div>
      <div class="tab_right" @click="tabDateClick">
        <el-date-picker
          ref="tab_date"
          class="tab_right_date"
          v-model="tab.date"
          type="date"
          format="MM-dd"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
          :editable="false"
          :clearable="false"
          @change="dateChange">
        </el-date-picker>
        <i class="el-icon-caret-bottom tab_right_icon"></i>
      </div>
    </div>
    <div v-show="!search.status" class="delivery">
    <!-- <div v-show="!search.status && ['0','1'].includes(tab.active)" class="delivery"> -->
      <div class="delivery-left">
        <div class="delivery-left-label">取药方式：</div>
        <div class="delivery-left-value">
          <span class="delivery-left-value-text">{{(delivery.options.find(item => item.value === delivery.active) || {}).label || ''}}</span>
          <i class="el-icon-caret-bottom tab_right_icon"></i>
          <el-select
            class="delivery-select"
            size="mini"
            popper-class="delivery-select-option"
            v-model="delivery.active"
            placeholder="请选择"
            @change="deliveryChange"
          >
            <el-option
              v-for="item in delivery.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="delivery-right">
        <div class="delivery-right-label">状态：</div>
        <div class="delivery-right-value">
          <span class="delivery-right-value-text">{{(statusList.find(item => item.value === statusVal) || {}).label || ''}}</span>
          <i class="el-icon-caret-bottom tab_right_icon"></i>
          <el-select
            class="delivery-select"
            size="mini"
            popper-class="delivery-select-option"
            v-model="statusVal"
            placeholder="请选择"
            @change="statusChange"
          >
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div v-if="!search.status" class="list_result">共 <span class="list_result_num">{{ user.total }}</span> 条信息 </div>
    <div class="list" v-infinite-scroll="listLoad" :infinite-scroll-immediate="false" :style="`height: calc( 100% - ${ !search.status && ['0', '1'].includes(tab.active) ? '374px' : '340px'} );`">
      <div
        v-for="item in user.list"
        :key="item.id"
        :class="{ list_item: true, active: user.active === item.prescriptionId }"
        @click="userChange(item)">
        <div class="list_item_left">
          <span :class="{ 'iconfont': true, 'icon-yonghu': true, 'list_item_left_icon': true, 'sex_woman': item.patientInfo.sex === '1' }"></span>
          <span class="list_item_left_name">{{ item.patientInfo.name || '匿名患者'}}</span>
          <span v-if="item.payStatus === 3" class="colorF54A size12 ml6">已退费</span>
        </div>
        <div class="list_item_right">
          <div class="list_item_right_time">{{computedTime(item) }}</div>
          <div class="list_item_right_status" :style="{color:computedStatusColor(item.status)}">{{ computedStatus(item) }}</div>
        </div>
      </div>
      <div v-show="user.list.length === 0" class="list_empty">暂无配方单</div>
    </div>
    <div class="tool">
      <div class="tool_title">小工具</div>
      <div class="tool_list">
        <div class="tool_item" @click="returnGoodsOpen">
          <div class="tool_item_left">
            <img class="tool_item_left_icon" :src="imgArr.formulaIcon" />
            <span class="tool_item_left_name">退货数据</span>
          </div>
          <div class="tool_item_right">
            <span class="tool_item_right_text">处理每日退货</span>
            <span class="el-icon-arrow-right tool_item_right_icon"></span>
          </div>
        </div>
        <div class="tool_item" @click="pickDialogOpen">
          <div class="tool_item_left">
            <img class="tool_item_left_icon" :src="imgArr.pickIcon" />
            <span class="tool_item_left_name">打包发货 </span>
          </div>
          <div class="tool_item_right">
            <span class="tool_item_right_text">处理配送单和自提单</span>
            <span class="el-icon-arrow-right tool_item_right_icon"></span>
          </div>
        </div>
        <div class="tool_item" @click="carryDialogOpen">
          <div class="tool_item_left">
            <img class="tool_item_left_icon" :src="imgArr.formulaIcon" />
            <span class="tool_item_left_name">带货数据</span>
          </div>
          <div class="tool_item_right">
            <span class="tool_item_right_text">处理每日带货</span>
            <span class="el-icon-arrow-right tool_item_right_icon"></span>
          </div>
        </div>
      </div>
    </div>
    <!-- 退货数据 -->
    <el-dialog
      title="退货数据"
      class="returnGood_dialog"
      :visible.sync="returnGoods.visible"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="returnGoodsClose">
      <div class="returnGoods_header">
        <div class="returnGoods_header_label">日期：</div>
        <el-date-picker
          class="returnGoods_header_date"
          v-model="returnGoods.date"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <el-button type="primary" class="returnGoods_header_btn" @click="returnGoodsSearch">查询</el-button>
        <el-button class="returnGoods_header_btn" @click="returnGoodsReset">重置</el-button>
      </div>
      <div class="returnGoods_table">
        <el-table
          :data="returnGoods.list"
          v-loading="returnGoods.loading"
          border
          max-height="280"
          style="width: 100%">
          <el-table-column prop="staticTime" label="日期" width="180"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="primary" @click="returnGoodsExport(scope.row)">导出</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="returnGoods_pagination">
        <el-pagination
          layout="total, prev, pager, next"
          :current-page="returnGoods.pageNo"
          :page-size="returnGoods.pageSize"
          :total="returnGoods.total"
          @current-change="returnGoodsPageNoChange">
        </el-pagination>
      </div>
    </el-dialog>
    <carry-dialog v-if="carryDialogObj.show" :carryDialogObj="carryDialogObj" @close="carryDialogClose"></carry-dialog>
    <pack-dialog v-if="pickDialogObj.show" :pickDialogObj="pickDialogObj" @close="pickDialogClose"></pack-dialog>
  </div>
</template>

<script>
  import { formulaDTO, CommonDTO } from '@/DTO/index';
  import { isNull, isEmptyArray, debounce,dictText } from '@/utils/validateBase';
  import { Utils } from '@/utils/utils';
  import { imgArr } from "@/assets/images/img.js";
  import { isNullObj } from '../../../utils/validateBase';
  import packDialog from './packDialog.vue'
  import carryDialog from './carryDialog.vue';
  export default {
    name: 'FormulaListLeft',
    components:{ packDialog,carryDialog },
    data() {
      return {
        imgArr: imgArr,
        clock: null,
        search: {
          keyword: '',
          status: false,
          pageNum: 1,
          pageSize: 100
        },
        tab: {
          active: '0',
          list: [
            {
              text: '待处理',
              mark: 0,
              status:'0'
            },
            {
              text: '已处理',
              mark: 0,
              status:'1'
            },
            {
              text: '已退费',
              mark: 0,
              status:'2'
            }
          ],
          startDate:null,
          endDate:null,
          date: new Date().Format('yyyy-MM-dd'),
        },
        delivery: {
          active: '',
          options: [
            { label: '全部', value: '' },
            { label: '自提', value: 0 },
            { label: '配送', value: 1 }
          ]
        },
        user: {
          active: '',
          list: [],
          total: 0
        },
        returnGoods: {
          visible: false,
          loading: false,
          date: [],
          pageNo: 1,
          pageSize: 10,
          list: [],
          total: 0
        },
        statusVal: '',
        statusList:[
          {value:'',label:'全部',color:'#000000'},
          {value:'1',label:'待收方',color:'#1890FF'},
          {value:'2',label:'待配方',color:'#FE8F1F'},
          {value:'3',label:'配方中',color:'#FE8F1F'},
          {value:'4',label:'待复核',color:'#FE8F1F'},
          {value:'5',label:'待加工',color:'#FE8F1F'},
          {value:'6',label:'加工中',color:'#FE8F1F'},
          {value:'7',label:'待打包',color:'#FE8F1F'},
          {value:'8',label:'待配送',color:'#29C01B'},
          {value:'9',label:'配送中',color:'#29C01B'},
          {value:'10',label:'待提货',color:'#29C01B'},
          {value:'11',label:'已完成',color:'#29C01B'},
          {value:'12',label:'已退费',color:'#F54A45'},
        ],
        childStatusList:[
          { value: 600101, label: '待泡药' },
          { value: 600102, label: '待熬药' },
          { value: 600103, label: '待装袋' },

          { value: 600201, label: '待泡药' },
          { value: 600202, label: '待熬药' },
          { value: 600203, label: '待浓缩' },
          { value: 600204, label: '待收膏' },
          { value: 600205, label: '待晾膏' },

          { value: 600301, label: '待打粉' },
          { value: 600302, label: '待熬药' },
          { value: 600303, label: '待制丸' },
          { value: 600304, label: '待烘干' },
          { value: 600305, label: '待分装' },

          { value: 600401, label: '待打粗粉' },
          { value: 600402, label: '待打细粉' },

          { value: 600501, label: '待加工' },
          { value: 600502, label: '加工中' }
        ],
        pickDialogObj:{
          show:false
        },
        carryDialogObj:{
          show:false
        }
      }
    },
    computed:{
      computedStatus(){
        return function(info){
          const status = info.status
          const childStatus = info.childStatus
          let text = ''
          if ([5, 6].includes(status)) {
            const node = this.childStatusList.find(item => { return item.value == childStatus })
            if (node) {
              text = node.label
            }
          } else if ([9].includes(status)) {
            if (info.deliveryWay === 0 && info.transferDeptId === 127) {
              text = '送回中'
            } else {
              text = '配送中'
            }
          } else if ([10].includes(status)) {
            if (info.deliveryWay === 0) {
              text = '待自提'
            } else {
              text = '待收货'
            }
          } else {
            const node = this.statusList.find(item => { return item.value == status })
            if (node) {
              text = node.label
            }
          }
          return text
        }
      },
      computedStatusColor(){
        return function(val){
          return isNullObj(this.statusList.find(item=>{ return item.value==val }))?'':this.statusList.find(item=>{ return item.value==val }).color || ''
        }
      },
      computedTime(){
        return function(row){
          let str = '';

          if (this.search.status) {
            str = row.handlingTime && new Date(row.handlingTime).Format('yyyy-MM-dd') || '';
          } else {
            let val = row.updateTime;
            if(this.search.status){
              str = this.$moment(val).valueOf() < Utils.startOfDay(this.$moment()) ? Utils.timeFormat(val,'MM-DD') : Utils.timeFormat(val,'HH:mm');
            }else{
              str =  isNull(val) ? '' : Utils.timeFormat(val,'HH:mm');
            }
          }
          
          return str;
        }
      },
    },
    created() {
      this.systemTime = CommonDTO.getSystemTimeDTO();
      this.getFormulaPage();
      this.clock = setInterval(() => {
        if (!this.search.status) {
          this.getFormulaPage(1);
        }
      }, 30000)
    },
    beforeDestroy() {
      clearInterval(this.clock);
    },
    methods: {
      // 刷新数据
      refreshData(){
        this.search.pageNum = 1;
        this.user.list = [];
        this.getFormulaPage();
      },
      // tab切换
      tabChange: debounce(function (index) {
        this.tab.active = this.tab.list[index].status;
        this.refreshData()
      }, 300),
      // 配送方式切换
      deliveryChange(){
        this.refreshData()
      },
      // 状态切换
      statusChange(){
        this.refreshData()
      },
      // 日期板块点击
      tabDateClick() {
        this.$refs['tab_date'].focus();
      },
      //选择日期
      dateChange(){
        this.refreshData()
      },
      // 用户切换
      userChange(row) {
        this.user.active = row.prescriptionId;
        this.$emit('getPrescriptionId', this.user.active)
      },
      //搜索
      handleSearch: debounce(async function(val){
        this.search.status = !isNull(val);
        this.search.pageNum = 1;
        this.user.list = [];
        this.user.total = 0;
        if (!isNull(val)) {
          let params = {
            deptId: sessionStorage.getItem('deptId'),
            matchCondition: this.search.keyword,
            pageNum: 1,
            pageSize: 100
          }
          let res = await formulaDTO.formulaPage(params)
          if(res.code == 200){
            this.user.list = res.data && res.data.data || [];
            this.user.total = res.data && res.data.totalElements || 0;
          }
        } else {
          this.getFormulaPage()
        }
      }, 300),
      // 分页查询配方单
      async getFormulaPage(pageNo){
        let { pageSize, pageNum, keyword } = this.search
        let params = {
          deptId: sessionStorage.getItem('deptId'),
          matchCondition: keyword,
          prescriptionStatus: this.tab.active * 1,
          startDate: isNull(keyword) ? Utils.startOfDay(this.tab.date) : this.tab.startDate,
          endDate: isNull(keyword) ? Utils.endOfDay(this.tab.date) : this.tab.endDate,
          pageNum: pageNo || pageNum,
          pageSize
        }

        params.drugWay = this.delivery.active
        if (this.statusVal !== '') {
          // 如果查询全部，则不传此参数
          params.statusList = [this.statusVal * 1]
        }

        let { code, data } = await formulaDTO.formulaPage(params)
        if(code == 200){
          data.data = (data.data || []).map(item => ({
            ...item,
            patientInfo: item.patientInfo || {
              "name": "",
              "sex": "",
              "sexName": "",
              "age": '',
              "month": '',
              "phone": "",
              "prescriptionNum": ''
            }
          }))
          this.tab.list.find(item => { return item.status === '0'}).mark = data.toBeprocessedNum || 0;
          this.tab.list.find(item => { return item.status === '1'}).mark = data.processedNum || 0;
          this.tab.list.find(item => { return item.status === '2'}).mark = data.refundedNum || 0;
          if (pageNo) {
            let oldList = JSON.parse(JSON.stringify(this.user.list));
            oldList.splice(0, this.search.pageSize);
            let remoteList = data && data.data || [];
            const newlist = remoteList.concat(oldList);
            this.user.list = newlist;
          } else {
            const list = data && data.data || [];
            this.user.list = this.user.list.concat(list);
          }
          this.user.total = data && data.totalElements || 0;
          if(data.data && !isEmptyArray(data.data)) {
            if(isNull(this.user.active)){``
              this.userChange(data.data[0])
            }
          }
          if((isNull(data.data) || isEmptyArray(data.data)) && isNull(this.user.active)){
            this.$emit('getPrescriptionId','')
          }
        } else {
          this.user.list = [];
          this.user.total = 0;
        }
      },
      // 滚动加载更多
      listLoad() {
        const pageCount = Math.ceil(this.user.total / this.search.pageSize);
        if (this.search.pageNum < pageCount) {
          this.search.pageNum = this.search.pageNum + 1;
          this.getFormulaPage();
        }
      },
      // 退货数据打开
      returnGoodsOpen() {
        this.returnGoods.visible = true;
        this.getReturnGoodsList();
      },
      // 退货数据关闭
      returnGoodsClose() {
        this.returnGoods.visible = false;
        this.returnGoods.date = [];
        this.returnGoods.pageNo = 1;
        this.returnGoods.total = 0;
        this.returnGoods.list = [];
      },
      // 获取退货数据
      getReturnGoodsList() {
        this.returnGoods.loading = true;
        formulaDTO.getReturnGoodsList({
          requestId: new Date().getTime(),
          deptId: sessionStorage.getItem('deptId'),
          startDate: this.returnGoods.date && this.returnGoods.date[0] || '',
          endDate: this.returnGoods.date && this.returnGoods.date[1] || '',
          pageNum: this.returnGoods.pageNo,
          pageSize: this.returnGoods.pageSize
        }).then(res => {
          this.returnGoods.loading = false;
          if (res.code === 200) {
            this.returnGoods.list = res.data.data && res.data.data || [];
            this.returnGoods.total = res.data.totalElements;
          }
        })
      },
      // 退货数据分页
      returnGoodsPageNoChange(num) {
        this.returnGoods.pageNo = num;
        this.getReturnGoodsList();
      },
      // 退货数据查询
      returnGoodsSearch() {
        this.returnGoods.pageNo = 1;
        this.getReturnGoodsList();
      },
      // 退货数据重置
      returnGoodsReset() {
        this.returnGoods.date = [];
        this.returnGoods.pageNo = 1;
        this.getReturnGoodsList();
      },
      // 退货数据导出
      returnGoodsExport(row) {
        if (row.statisticId) {
          formulaDTO.returnGoodsExport({ statisticId: row.statisticId }, { name: `${row.staticTime}退货数据报表` })
        }
      },
      pickDialogClose(){
        this.pickDialogObj.show = false
      },
      pickDialogOpen(){
        this.pickDialogObj.show = true
      },
      carryDialogClose(){
        this.carryDialogObj.show = false
      },
      carryDialogOpen(){
        this.carryDialogObj.show = true
      }
    }
  }
</script>

<style lang="less" scoped>
  .formulaListLeft{
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .header{
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 56px;
    border-bottom: 1px solid #E0E0E0;
  }

  .header_search{
    width: 270px;
  }

  .tab{
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px;
    width: 100%;
    height: 34px;
    border-bottom: 1px solid #E0E0E0;
  }

  .tab_list{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 100%;
  }

  .tab_list_item{
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    width: fit-content;
    height: 100%;
    cursor: pointer;
  }

  .tab_list>.tab_list_item:not(:first-child){
    margin: 0 0 0 24px;
  }

  .tab_list_item_text{
    font-weight: bold;
    font-size: 14px;
    color: #667182;
  }

  .tab_list_item_mark{
    position: absolute;
    z-index: 2;
    top: 8px;
    left: calc( 100% + 2px );
    font-size: 12px;
    color: #F54A45;
  }

  .tab_list_item.active::after{
    content: '';
    position: absolute;
    z-index: 2;
    bottom: -1px;
    left: 0px;
    display: block;
    width: 100%;
    height: 2px;
    background-color: #1890FF;
  }

  .tab_list_item.active .tab_list_item_text{
    color: #000000;
  }

  .tab_right{
    display: flex;
    justify-content: flex-start;
    align-content: center;
  }

  .tab_right_date{
    width: 40px;
  }

  .tab_right_date /deep/ .el-input__inner {
    padding: 0;
    color: #667182;
    border: none;
    cursor: pointer;
  }

  .tab_right_date /deep/ .el-input__prefix {
    display: none;
  }

  .tab_right_icon{
    line-height: 32px;
    color: #667182;
    cursor: pointer;
  }

  .search_result{
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 12px;
    width: 100%;
    height: 34px;
    font-size: 14px;
    color: #667182;
    border-bottom: 1px solid #E0E0E0;
  }

  .search_result_num{
    margin: 0 4px;
    color: #000000;
  }

  .delivery{
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 12px;
    width: 100%;
    height: 34px;
    border-bottom: 1px solid #E0E0E0;
  }

  .delivery-left {
   margin-right: 20px; 
  }

  .delivery-left, .delivery-right{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 13px;
    color: #000000;
  }

  .delivery-left-label,.delivery-right-label{
    white-space: nowrap;
    color: #667182;
  }

  .delivery-left-value,.delivery-right-value {
    position: relative;
  }

  .delivery-left-value-text,.delivery-right-value-text {
    white-space: nowrap;
    margin-right: 4px;
  }

  .delivery-select{
    position: absolute;
    left: 0;
    width: 56px;
    opacity: 0;
  }

  // 下拉框option样式
  .delivery-select-option .el-select-dropdown__item {
    box-sizing: border-box;
    padding: 0 15px;
    width: 120px;
    height: 32px;
    line-height: 32px;
  }
  .list_result{
    height: 28px;
    line-height: 28px;
    background: #FFFDE9;
    color: #667182;
    font-size: 14px;
    text-align: center;
  }
  .list_result_num{
    color: #000000;

  }
  .list{
    box-sizing: border-box;
    padding: 8px 12px;
    width: 100%;
    height: calc( 100% - 90px );
    overflow-x: hidden;
    overflow-y: auto;
  }

  .list_item{
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 8px;
    width: 100%;
    height: 40px;
    border-radius: 4px;
    cursor: pointer;
  }

  .list_item:hover{
    background-color: #F0F1F3;
  }

  .list>.list_item:not(:first-child){
    margin: 8px 0 0 0;
  }

  .list_item_left{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .list_item_left_icon{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    font-size: 12px;
    color: #1890FF;
    background-color: #FFFFFF;
    border: 1px solid #F6F6F6;
    border-radius: 2px;
  }

  .list_item_left_icon.sex_woman{
    color: #FF3194;
  }

  .list_item_left_name{
    margin: 0 0 0 6px;
    font-size: 14px;
    color: #000000;
  }

  .list_item_right{
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .list_item_right_time{
    font-size: 12px;
    color: #000000;
  }

  .list_item_right_status{
    margin: 0 0 0 16px;
    width: 40px;
    font-size: 12px;
    color: #1890FF;
  }

  .list_item.active{
    background-color: #1890FF;
  }

  .list_item.active .list_item_left_name, .list_item.active .list_item_right_time, .list_item.active .list_item_right_status{
    color: #FFFFFF !important;
  }

  .list_empty{
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 100px 0 0 0;
    width: 100%;
    font-size: 14px;
    color: #A4AFBA;
  }

  .tool{
    box-sizing: border-box;
    width: 100%;
    height: 250px;
    border-top: 1px solid #E0E0E0;
  }

  .tool_title{
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 12px;
    width: 100%;
    height: 34px;
    font-weight: bold;
    font-size: 14px;
    color: #000000;
    border-bottom: 1px solid #E0E0E0;
  }

  .tool_list{
    box-sizing: border-box;
    width: 100%;
    height: calc( 100% - 34px );
    overflow-x: hidden;
    overflow-y: auto;
  }

  .tool_item{
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px;
    width: 100%;
    height: 48px;
    cursor: pointer;
  }

  .tool_item_left{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .tool_item_left_icon{
    width: 24px;
    height: 24px;
  }

  .tool_item_left_name{
    margin: 0 0 0 6px;
    font-size: 14px;
    color: #000000;
  }

  .tool_item_right{
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .tool_item_right_text{
    font-size: 14px;
    color: #9AA0A8;
  }

  .tool_item_right_icon{
    margin: 0 0 0 6px;
    font-size: 14px;
    color: #9AA0A8;
  }

  .returnGood_dialog /deep/ .el-dialog__body{
    padding: 12px 20px;
  }

  .returnGoods_header{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .returnGoods_header_label{
    flex-shrink: 0;
    font-size: 14px;
    color: #000000;
  }

  .returnGoods_header_date{
    width: 240px;
  }

  .returnGoods_header_date.el-date-editor /deep/ .el-range__close-icon{
    line-height: 24px;
  }

  .returnGoods_header_btn{
    margin: 0 0 0 8px;
  }

  .returnGoods_table{
    margin: 12px 0 0 0;
    width: 100%;
  }

  .returnGoods_pagination{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 12px 0 0 0;
    width: 100%;
  }
</style>
